import { render, staticRenderFns } from "./uploadPage.vue?vue&type=template&id=4f3dc916&scoped=true"
import script from "./uploadPage.vue?vue&type=script&lang=js"
export * from "./uploadPage.vue?vue&type=script&lang=js"
import style0 from "./uploadPage.vue?vue&type=style&index=0&id=4f3dc916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3dc916",
  null
  
)

export default component.exports